import React, { useEffect, useState } from "react";
import { API_BASE } from "../../lib/api";

export default function LiveTicker() {
  const [t, setT] = useState(null);
  useEffect(() => {
    fetch(`${API_BASE}/public/ticker`, { credentials: "omit" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d) setT(d); })
      .catch(() => { /* silent */ });
  }, []);
  const stats = [
    { label: "Companies evaluated", value: t?.companies_evaluated, testId: "ticker-companies" },
    { label: "Institutions on file", value: t?.institutions_on_file, testId: "ticker-institutions" },
    { label: "Term sheets · last 7 days", value: t?.term_sheets_this_week, testId: "ticker-term-sheets" },
    { label: "Median trust score", value: t?.median_score != null ? `${t.median_score} / 100` : null, testId: "ticker-median" },
  ];
  return (
    <section className="bg-white border-b border-navy/10" data-testid="live-ticker">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 grid grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((s) => (
          <div key={s.label} className="flex items-baseline gap-3" data-testid={s.testId}>
            <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse shrink-0 mt-2" />
            <div>
              <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-ink-muted">{s.label}</div>
              <div className="font-heading text-ink text-lg mt-0.5">
                {s.value == null ? <span className="text-ink-faint">—</span> : s.value}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
